import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const FirstFoldImages = (preloadFirstFoldImages)=>/*#__PURE__*/ _jsx(_Fragment, {
        children: preloadFirstFoldImages === null || preloadFirstFoldImages === void 0 ? void 0 : preloadFirstFoldImages.map((image, index)=>/*#__PURE__*/ _jsx("link", {
                rel: "preload",
                href: image === null || image === void 0 ? void 0 : image.src,
                as: "image"
            }, `${image === null || image === void 0 ? void 0 : image.src}${index}`))
    });
export default FirstFoldImages;
